import { all, takeEvery } from "redux-saga/effects";
import * as aTypes from "../actions/actionTypes";
import { initFetchMyUsersSaga } from "./_ApiMyUsers";
import { initFetchCodeSaga } from "./_ApiCode";
import { initFetchTasksSaga } from "./_ApiTasks";
import { initFetchPlansSaga } from "./_ApiPlans";
import { initFetchActivitiesSaga } from "./_StaticActivities";
import { initFetchContentsSaga } from "./_StaticContents";
import { initSetSessionActiveSaga } from "./_LocalSession";
import { initFetchBestplaysSaga } from "./_ApiStatistics";
import { initFetchProductsSaga } from "./ApiProducts";
// import {
//   initFetchPatientsStats,
//   initFetchUserProgressStats,
//   initFetchGeneralProgressStats,
// } from "./__deletar?___statistics";
// import { initFetchPlans } from "./__deletar?___plans";

// ========================================
// ================== V3 ==================
// ========================================

export function* watchCode() {
  yield all([takeEvery(aTypes.V3_CODE_INIT, initFetchCodeSaga)]);
}

export function* watchTasks() {
  yield all([takeEvery(aTypes.V3_TASKS_INIT, initFetchTasksSaga)]);
}

export function* watchPlans() {
  yield all([takeEvery(aTypes.V3_PLANS_INIT, initFetchPlansSaga)]);
}

export function* watchProducts() {
  yield all([takeEvery(aTypes.PRODUCTS_INIT, initFetchProductsSaga)]);
}

export function* watchStatistics() {
  yield all([takeEvery(aTypes.V3_BESTPLAYS_INIT, initFetchBestplaysSaga)]);
}

// ========================================
// ================== V2 ==================
// ========================================

/**
 * Routes [STEPS]
 * Step 02: Saga will catch  this type: ACTIVTS_INIT and call initFetchActivitiesSaga()
 * > Go to: ./activities.js
 */
// Saga generators
export function* watchActivities() {
  yield all([takeEvery(aTypes.ACTIVTS_INIT, initFetchActivitiesSaga)]);
}

export function* watchContents() {
  yield all([takeEvery(aTypes.CONTS_INIT, initFetchContentsSaga)]);
}

export function* watchSession() {
  yield all([takeEvery(aTypes.SESSION_INIT_ACTIVE, initSetSessionActiveSaga)]);
}

export function* watchMyUsers() {
  yield all([takeEvery(aTypes.V3_MY_USERS_INIT, initFetchMyUsersSaga)]);
}

// export function* watchStatistics() {
//   yield all([
//     takeEvery(aTypes.STATS_PATIENTS_INIT, initFetchPatientsStats),
//     takeEvery(aTypes.STATS_MY_PROG_INIT, initFetchUserProgressStats),
//     takeEvery(aTypes.STATS_GENERAL_PROG_INIT, initFetchGeneralProgressStats),
//   ]);
// }

// export function* watchPlans() {
//   yield all([takeEvery(aTypes.PLANS_INIT, initFetchPlans)]);
// }
